






import { Component, Vue, Prop } from 'vue-property-decorator';
import BankId from '../assets/bankid.svg';
import BankIdNo from '../assets/bankid-no.svg';
import NemId from '../assets/nemid.svg';
import NemIdOrg from '../assets/nemid-organization.svg';
import MitIdDark from '../assets/mitid-dark.svg';
import type { EIdIconType } from '../types/enums/eid-icon-type';

@Component({
  components: {
    BankId,
    BankIdNo,
    NemId,
    NemIdOrg,
    MitIdDark,
  },
})
export default class EIdIcon extends Vue {
  @Prop() type: EIdIconType;
}
